export default function getDataWithGroupAttached({ data, group }) {
    return data.map((item) => ({
        ...item,
        serviceLevel: item.serviceLevel && item.serviceLevel.name,
        group,
        createdAt: new Date(),
    }));
}
